import React, {useEffect, useState} from "react";
import "./DSAManager.scss";
import DSAManagerHeader from "../dsa/DSAManagerHeader";
import { Route, Routes } from "react-router-dom";
import DSAManage from "./DSAManage";
import DSAPlaylists from "./DSAPlaylists";
import DSASchedules from "./DSASchedules";
import DSAUploads from "./DSAUploads";
import {DsaScreenDto} from "../../generated/dashboard-client";
import DSAApi from "../../api/DSAApi";
import {handleServerError} from "../../util/ErrorHandler";
import {useRecoilState} from "recoil";
import {locationsState} from "../../state/atoms";

export interface Props {
  isMarketingBannerPage: boolean;
}

export default function DSAManager({isMarketingBannerPage} : Props) {
  const [filteredScreens, setFilteredScreens] = useState([] as DsaScreenDto[]);
  const [screens, setScreens] = useState([] as DsaScreenDto[]);
  const [availableDevices, setAvailableDevices] = useState(0);
  const [locations] = useRecoilState(locationsState);

  useEffect(() => {
    const screensInLocation = screens.filter(sc => locations.map(loc => loc.internalId).includes(sc.locationId));
    setFilteredScreens(screensInLocation);
  }, [screens, locations]);

  useEffect(() => {
    DSAApi.getScreens()
      .then(r => setScreens(r.data))
      .catch(e => handleServerError(e, "Failed to fetch devices."));

    DSAApi.getScreensTotal().then(r => {
      setAvailableDevices(r.data);
    }).catch(e => {
      handleServerError(e, "Failed to fetch available devices.");
    });
  }, [locations]);

  return <div>
    <DSAManagerHeader isMarketingBannerPage={isMarketingBannerPage} screens={screens} availableDevices={availableDevices} />
    <Routes>
      <Route path={"/manage"} element={<DSAManage />} />
      <Route path={"/playlists"} element={<DSAPlaylists screens={filteredScreens} />} />
      <Route path={"/schedules"} element={<DSASchedules isMarketingBannerPage={isMarketingBannerPage} screens={filteredScreens} />} />
      <Route path={"/uploads"} element={<DSAUploads />} />
    </Routes>
  </div>
}
